import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'

import { Container, Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import FontIcon from '../../../../../SPRINTA/atoms/FontIcon'
import ConfigData from '../ConfigData'
import ConfigFinance from '../ConfigFinance'
import ConfigOrganizer from '../ConfigOrganizer'
import ConfigBilling from '../ConfigBilling'
import ConfigDocuments from '../ConfigDocuments'
import ConfigApps from '../ConfigApps'

import T from '../../../../../SPRINTA/translate/T'

import style from './style.css'
class Config extends Component {
  state = {
    menuActive: false
  }

  componentWillReceiveProps( nextProps ) {
    if(nextProps.page !== this.props.page) {
      this.handleToggleMenu(false)
    }
  }

  handleToggleMenu( status ) {
    
    if(status === undefined) {
      status = !this.state.menuActive
    }

    this.setState({
      menuActive: status
    })
  } 

  render() {
      return (
        <Container>
          <Row>
            <div className={style.flexHeight}>
              <Col size='8 4 3' className={`${style.responsiveMenu} ${this.state.menuActive ? style.active : ''}`}>
                <div className={style.menuFix} />
                
                <div onClick={() => this.handleToggleMenu() } className={style.menuHamburger}>
                  <FontIcon name='menu' />
                </div>
                <ul className={style.menu}>
                  <li className={this.props.page === 'home' ? style.active : ''}>
                    <Link to={`/user/${this.props.username}/config`}>
                      {T.text('my_data')} <span className={style.icon}><FontIcon name='admin_team'/></span>
                    </Link>
                  </li>
                  <li className={this.props.page === 'documents' ? style.active : ''}>
                    <Link to={`/user/${this.props.username}/config/documents`}>
                      {T.text('documents_data')} <span className={style.icon}><FontIcon name='admin_data'/></span>
                    </Link>
                  </li>
                  <li className={this.props.page === 'finance' ? style.active : ''}>
                    <Link to={`/user/${this.props.username}/config/finance`}>
                      {T.text('financial_data')} <span className={style.icon}><FontIcon name='user_finance'/></span>
                    </Link>
                  </li>
                  <li className={this.props.page === 'billing' ? style.active : ''}>
                    <Link to={`/user/${this.props.username}/config/billing`}>
                      {T.text('billing_title')} <span className={style.icon}><FontIcon name='admin_finance'/></span>
                    </Link>
                  </li>
                  <li className={this.props.page === 'apps' ? style.active : ''}>
                    <Link to={`/user/${this.props.username}/config/apps`}>
                      {T.text('apps_data')} <span className={style.icon}><FontIcon name='user_apps'/></span>
                    </Link>
                  </li>
                  <li className={this.props.page === 'organizer' ? style.active : ''}>
                    <Link to={`/user/${this.props.username}/config/organizer`}>
                      {T.text('organizer_data')} <span className={style.icon}><FontIcon name='admin_config'/></span>
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col size='12 8 9'>
                <div style={{ padding: '30px 0'}}>
                  <Col hiddenLG hiddenMD size='12'> <br /> <br /> </Col>
                  
                  <Route exact path="/user/:user/config" component={ConfigData} />
                  <Route exact path="/user/:user/config/finance" component={ConfigFinance} />
                  <Route exact path="/user/:user/config/organizer" component={ConfigOrganizer} />
                  <Route exact path="/user/:user/config/billing" component={ConfigBilling} />
                  <Route exact path="/user/:user/config/apps" component={ConfigApps} />
                  <Route exact path="/user/:user/config/documents" component={ConfigDocuments} />
                </div>
              </Col>
            </div>
          </Row>
        </Container>
      )
  }
}

const mapStateToProps = store => ({
   user: store.user
 })
 const mapDispatchToProps = {
 
 }
 export default connect( mapStateToProps, mapDispatchToProps )(Config)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Config/index.js